export const locale = {
  lang: 'nl',
  data: {
    'AVANCES': {
      'GOSURVEY': 'Ga naar de enquête',
      'GOPORTAL': 'Ga naar het telportaal',
      'REGRESAR': 'Terug',
      'DESCARGAR': 'Download excel',
      'PRIMEROS': 'Haal de eerste 1000 rijen',
      'SINCRONIZAR': 'Synchroniseer met telportaal',
      'AGREGAR': 'Toevoegen',
      'PRODUCTO': 'Product',
      'FEC-LAN': 'Lanceringsdatum',
      'FEC-CIE': 'Afsluitingsdatum',
      'NOFEC-LAN': 'Je hebt nog geen lanceringsdatum gepland.',
      'FEC-CIE-PROR': 'Sluitingsdatum verlengd',
      'CER': 'Close Survey',
      'ABR': 'Open onderzoek',
      'SURVEY': 'Onderzoek. ',
      'FILE': 'Cultura Go Cloud Drive: ',
      'PROR': 'ONDERZOEK UITBREIDEN',
      'WARNING-FECHA-GUARDAR': 'Weet u zeker dat u gedateerde extensies zult toevoegen',
      'SUCCESS-PRORROGA': 'De sluitingsdatum is gewijzigd in ',
      'WARNING-CIERRE-ENCUESTA': 'Weet u zeker dat u de status van de enquête zult wijzigen',
      'SUCCESS-CIERRE': 'De enquête is correct gewijzigd',
      'PORCENTAJE': 'Preview of responses: ',
      'DES': 'Klik om te laten zien',
      'WARNING-BTN': 'Deze actie kan niet worden voltooid omdat uw enquête niet is gestart',
      'PROCESARRESU': 'Verwerk resultaten',
      'ETIQUETAS':{
        'ETIQUETAS': 'Artikelen per pagina',
        'OF': 'van',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          'MESSAGE1':'<span>Om de verwijdering van de antwoorden van de gebruiker te bevestigen',
          'MESSAGE2':', voer de gebruikersnaam in het tekstvak</span>',
          'MESSAGE3':'<span>Om de verwijdering van de antwoorden van de gebruiker te bevestigen, voert u de volgende gebruikersnaam in het tekstvak in ',
          'SALIR': 'Exit',
          'VALIDAR': 'Bevestig gebruiker',
          'ERRORNOMBREEMPRESA': 'De naam van de ingevoerde gebruiker komt niet overeen met de naam van de gebruiker die u wilt verwijderen Weet je het zeker? Je staat op het punt om de antwoorden van de gebruikers te verwijderen',
          'Annuleren': 'Annuleren',
          'CONFIRMAR': 'Ja, schrappen',
          'SUCCES': 'De antwoorden werden geschrapt',
          'CERRAR': 'Sluiten',
        },
        'MESSAGE': 'Weet u zeker dat u de antwoorden van de gebruiker wilt verwijderen',
        'RESP_SI': 'Ja',
        'RESP_NO': 'Nee',
        'ACEPTAR':' Accepteer',
        'ANNULEREN': 'Annuleren',
        'OK': 'Ok',
        'SUCCESS-DELETE': 'Antwoorden met succes verwijderd',
        'ERROR-DELETE': 'Er is iets misgegaan',
      },
      'PROCESAR': {
        'OK': 'Het proces is succesvol gestart',
        'NOTOK': 'Het proces kan niet starten, eerst moet u de gewenste resultaten instellen'
      },
      'INS':{
        'INS1':' van ',
        'INS2':' collaborateurs ...',
      },
      "INICIO":{
        'TITULO': 'Enquêtestatus per gebruiker',
        'INSTRUCCIONES': 'Aan de linkerkant staat een balk met de producten die het bedrijf heeft gekocht. Als u op één ervan klikt, kunt u de klanten per jaar selecteren om de lijst van gebruikers te kunnen laten zien die de enquête van dat product uitvoeren.',
      },
      'ENCUESTA':{
        'TTITULO': 'Voortgangsonderzoek per gebruiker',
        'PRODUCTEN': 'Eigen producten',
        'LABEL01': 'Naam',
        'LABEL02': 'E-mail',
        'LABEL03': 'Onderzoekssleutel',
        'LABEL04': 'Status',
        'LABEL05': 'Uitnodiging',
        'LABEL06': 'Herinnering',
        'LABEL07': 'Schrap',
        'LABEL08': 'Start',
        'LABEL09': 'Einde',
        'LABEL10': 'Gebruikersacties',
        'LABEL11': 'Enquêteacties',
        'LABEL12': 'Toegangssleutel',
        'DESCARGAR': 'Downloaden, wacht even...',
        'BUSCAR': 'Zoeken',
        'TITULOEXCEL': 'Enquêtestatus',
        'CARGANDO': 'Laden',
        'ACTIVA': 'Survey not enable',
        //, wacht even... Uw totale medewerkers:
        'PLACE': 'Schrijf de naam van de medewerker die u zoekt',
        'ACTIES': 'Speciale acties',
        'NOUSER': 'Zoek niet gevonden',
        'NA': 'Niet beschikbaar',
        'ERROR': 'Dit product heeft nog geen enquête',
        'SUCCESS1': 'Uitnodiging verzonden',
        'SUCCESS2': 'Herinnering verzonden',
        'ERROR1': 'Er is iets misgegaan',
      },
      'TITULOS':{
        'NAME': 'Naam van de medewerker',
        'ESTADOS': 'Status van de enquête',
        'FECHA1': 'Enquête beginnen',
        'FECHA2': 'Einde onderzoek',
        'ESTADOS_ENC':{
          'TITULO': 'Selecteer een optie',
          'TODO': 'Toon alles',
          'ESTADO1': 'Niet begonnen met de enquête',
          'ESTADO2': 'De gebruiker is erin geluisd',
          'ESTADO3': 'Onderzoek naar de voortgang',
          'ESTADO':'Enquête voltooi',
          'ESTADO5': 'Niet geaccepteerd',
          'ESTADO6':'Ik accepteer de enquête',
        }
      },
      'COLUMNAS':{
        'E-mail': 'E-mail',
        'end_date': 'Einddatum',
        'id_status': 'Status',
        'name': 'Naam',
        'start_date': 'Startdatum',
      },
      'ACCIONES_EMAIL':{
        'ACCIONES': 'Acties met betrekking tot de enquête',
        'INFO':'De volgende stappen tonen u de acties die voor de gebruiker haalbaar zijn',
        'ACC1': 'Uitnodiging sturen',
        'ACC2': 'Stuur een herinnering',
        'ACC3': 'Schrap het antwoord op de enquête',
      },
      'NEWCOLAB': {
        'TITULO': 'Nieuwe deelnemer toevoegen aan de enquête',
        'INST_1': 'Vul elk van de vereiste gegevensreeksen in om een nieuwe deelnemer toe te voegen',
        'TITULO_MOD': 'Wijzig de gegevens van de medewerkers',
        'INST_1_MOD': 'U kunt wijzigingen aanbrengen in elk van de datasets van de geselecteerde medewerker',
        'INST_2': 'De met (*) gemarkeerde velden zijn verplicht',
        'WARNING1': 'LET OP: DE SLEUTEL VAN DEZE MEDEWERKER',
        'WARNING2':' KAN NIET WORDEN GEWIJZIGD',
        'DATASET_1': 'Dataset 1',
        'DATASET_2': 'Dataset 2',
        'DATASET_3': 'Dataset 3',
        'DATASET_4': 'Dataset 4',
        'DATASET_5': 'Dataset 5',
        'DATASET_6': 'Dataset 6',
        'DATASET_7': 'Dataset 7',
        'REQUIRED': 'Dit veld is verplicht',
        'NEXT': 'Volgende',
        'BACK': 'Vorige',
        'SAVE': 'SAVE',
        'ERR_OWNKEY': 'Het ingevoerde werknemersnummer is al opgeslagen in de database, probeer een andere',
        'ERR_BOSSKEY': 'Het ingevoerde baasnummer wordt niet opgeslagen in de database, probeer een andere',
        'ERR_VAL_1': 'De in het veld ingevoerde gegevens: ',
        'ERR_VAL_2': ' bevat illegale tekens, of is niet in het juiste formaat',
        'GUARDANDO': 'Informatie over de deelnemers wordt opgeslagen, wacht even',
        'GUARDANDO_GOFLOW': 'De informatie wordt opgeslagen, gelieve te wachten.',
        'SAVE_OK': 'De informatie van de nieuwe deelnemer is correct opgeslagen',
        'MOD_OK': 'De deelnemersinformatie is succesvol gewijzigd',
        'FORMULARIO': 'U hebt het registratieformulier nog niet ingevuld, controleer of u alle verplichte velden hebt ingevuld en probeer het opnieuw',
        'ACCIES': 'Acties',
        'VERACT': 'Gebruikersacties',
        'LOADACT': 'Laden van beschikbare acties',
        'NOACT': 'Er kunnen geen extra acties worden uitgevoerd voor deze bijdrager',
        'AVAACT': 'De volgende acties kunnen worden uitgevoerd voor de medewerker',
        'ACCIONLIST': {
          'Modificar': 'Wijziging van de informatie van de geselecteerde medewerker',
          'Borrar': 'Verwijder de geselecteerde medewerker',
        },
        'DELCOLAB': 'Bevestigt u dat u de geselecteerde medewerker van dit product wilt verwijderen? Opmerking: Deze actie kan niet worden teruggedraaid',
        'DEL_OK': 'Deze medewerker is met succes uit het product verwijderd',
        'ERR_EMAIL': 'Het ingevoerde e-mailadres is al opgeslagen in de database, probeer een ander',
        'ERR_SAMEKEY': 'De ingevoerde bossleutel en de medewerkerssleutel zijn hetzelfde, dit mag niet, probeer een andere',
        'RESET_COLAB_SURVE': 'Bevestigt u dat u de toegang tot de enquête wilt resetten? ',
        'ACTU_OK': 'Het werd correct bijgewerkt',
      },
      'FORMULARIO_GO_FLOW':{
        'perspective': 'Perspectief',
        'statementID': 'Reactive ID',
        'dimensionL1': 'Dimensie L1',
        'dimensionL2': 'Dimensie L2',
        'survey_Score_OverallTI': 'GlobalTI Score Onderzoek',
        'company_Country': 'Land Bedrijf',
        'cgo_Product_Name': 'Productnaam cgo',
        'company_Name': 'Naam bedrijf',
        'ranking_Year': 'Rangschikking jaar',
        'survey_Respondents': 'Respondenten',
        'survey_Score_Camaraderie': 'Camaraderie Score Enquête',
        'survey_Score_Credibility': 'Geloofwaardigheid Score Enquête',
        'survey_Score_Imparciality': 'Onpartijdigheid Score Enquête',
        'survey_Score_Pride': 'Trots Score Onderzoek',
        'survey_Score_Respect': 'Respect Score Enquête',
        'survey_Score_Gestalt': 'Gestalt Score Enquête',
        'pdf_DateCreation': 'Datum waarop het certificaat is aangemaakt',
        'WARNI_TI_DA': 'De ingevoerde waarde stemt niet overeen met het toegestane formaat (100,00)',
        'WARNI_TI_DA_GRAL': 'De ingevoerde gegevens zijn niet in het opgegeven formaat',
      },
      'FORMULARIO':{
        'fullName': 'FULL NAME',
        'ownKey': 'WERKNEMERSNUMMER',
        'age': 'JAAR VAN GEBOORTE',
        'surveyKey': 'ENQUÊTE-TOEGANGSSLEUTEL',
        'E-mail': 'EMAIL',
        'bossName': 'DIRECT BOSS NAME',
        'bossKey': 'DIRECTE BAASNUMMER',
        'country': 'LAND',
        'location': 'LOCATIE',
        'geo_1': 'GEOGRAFISCHE NIVEAU 1',
        'geo_2': 'GEOGRAFISCHE NIVEAU 2',
        'geo_3': 'GEOGRAFISCHE NIVEAU 3',
        'geo_4': 'GEOGRAFISCHE NIVEAU 4',
        'geo_5': 'GEOGRAFISCHE NIVEAU 5',
        'geo_6': 'GEOGRAFISCHE NIVEAU 6',
        'geo_7': 'GEOGRAFISCHE NIVEAU 7',
        'geo_8': 'GEOGRAFISCHE NIVEAU 8',
        'geo_9': 'GEOGRAFISCHE NIVEAU 9',
        'geo_10': 'GEOGRAFISCHE NIVEAU 10',
        'geo_19': 'GEOGRAFISCHE NIVEAU 19',
        'structure_1': 'STRUCTURELE NIVEAU 1',
        'structure_2': 'STRUCTURELE NIVEAU 2',
        'structure_3': 'STRUCTURELE NIVEAU 3',
        'structure_4': 'STRUCTUURLIJKSE NIVEAU 4',
        'structure_5': 'STRUCTUURLIJKSE NIVEAU 5',
        'structure_6': 'STRUCTUURLIJKSE NIVEAU 6',
        'structure_7': 'STRUCTUURLIJKSE NIVEAU 7',
        'structure_8': 'STRUCTUURLIJKSE NIVEAU 8',
        'structure_9': 'STRUCTURELE NIVEAU 9',
        'structure_10': 'STRUCTURELE NIVEAU 10',
        'area': 'AREA',
        'bUnit': 'BUSINESS UNIT',
        'enterDate': 'DATUM VAN ENTRY TO THE COMPANY',
        'antiquity': 'ANTIQUITEIT',
        'antiquityUS': 'ANTIQUITY US',
        'generation': 'GENERATIE',
        'generationUS': 'GENERATIE VS',
        'ageUS': 'LEEFTIJD',
        'charge': 'POSITIE OF FUNCTIE IN DE VENNOOTSCHAP',
        'Homologado': 'CHARGE OR FUNCTION APPROVED',
        'homologadoUS': 'CHARGE OR FUNCTION APPROVED US',
        'gender': 'GENDER',
        'genderType': 'TYPE OF GENDER',
        'typeofwork ': 'TYPE OF COMPENSATION',
        'workCondition': 'Werkvoorwaarde',
        'academico': 'ACADEMIC DEGREE',
        'Contratacion': 'CONTRACT TYPE',
        'situacionUS': 'WORK SITUATION US',
        'personal': 'EMPLOYEE TYPE',
        'jornada': 'TYPE OF WORK SCHEDULE',
        'rotacion': 'DOES SHIFT ROTATION',
        'phone': 'COLLABORATORS PHONE',
        'extension': 'DIRECT EXTENSION OF THE COLLABORATOR',
        'cellphone': 'COLLABORATORS CELLPHONE',
        'native': 'NATIVE LANGUAGE',
        'answer': 'ANTWOORD',
        'other_1': 'Andere_1',
        'other_2': 'Andere_2',
        'other_3': 'Andere_3',
        'other_4': 'Andere_4',
        'other_5': 'Andere_5',
        'other_6': 'Andere_6',
        'other_7': 'Andere_7',
        'other_8': 'Andere_8',
        'other_9': 'Andere_9',
        'other_10': 'Andere_10',
      },
      'SINCRONIZACION':{
        'SINCRONIZANDO': 'Synchroniseren met telportaal, wacht even...',
        'SUCCESS':'Synchronisatie correct uitgevoerd',
      }
    },
  }
};
